import React, { useState } from 'react';
import { useField } from 'formik';
import validationService from 'app/core/services/validationService';
import Input from 'app/common/components/Elements/Input';
import { InputPasswordFieldProps } from './types';

const InputPasswordField01: React.FC<InputPasswordFieldProps> = ({ wrapClassName, label, className, onRedirectToForget, validate, ...props }) => {
  const [field, meta] = useField({ name: props.name, validate: validateField });
  const [isProtected, setIsProtected] = useState<boolean>(true);
  const [validGroup, setValidGroup] = useState<boolean[]>([false, false, false, false, false]);

  /**
   * @description 驗證 Field
   * @param value Field value
   */
  function validateField (value: string) {
    if (!validate) return;
    const validGroupUpdated = [...validGroup];
    // 檢核規則：8-20 個字元。
    const lengthIsValid = value.length >= 8 && value.length <= 20;
    validGroupUpdated.splice(0, 1, lengthIsValid);
    // 檢核規則：需包含大小寫英文及數字。
    validGroupUpdated.splice(1, 1, lengthIsValid ? !!value.match(validationService.containLowercaseAndUppercaseAndNumberRegExp) : false);
    // 檢核規則：不得設定四個以上連續升幂、降幂或相同之英數字。
    validGroupUpdated.splice(2, 1, lengthIsValid ? !(value.match(validationService.enCharactersOrNumbersConsecutive4CharactersRegExp) || value.match(validationService.ascendingConsecutive4CharactersRegExp) || value.match(validationService.descendingConsecutive4CharactersRegExp)) : false);
    // 檢核規則：不得同身分證字號或帳號。
    validGroupUpdated.splice(3, 1, lengthIsValid ? !(value === props.validateCondId) : false);
    // 檢核規則：可設定特殊符號，但不得設定：/、\、$、&、空白或全型英數字。
    validGroupUpdated.splice(4, 1, lengthIsValid ? !(value.match(validationService.fullZhHantTWCharactersRegExp) || value.match(validationService.fullEnCharactersAndNumbersRegExp) || (value.includes('/') || value.includes('$') || value.includes('&') || value.includes('\\') || value.includes(' '))) : false);
    // 更新檢核狀態
    setValidGroup(validGroupUpdated);
    // 觸發 Field error
    if (meta.touched && validGroupUpdated.includes(false)) return 'error';
  };

  /**
   * @description 處理密碼 顯示/隱藏 切換
   */
  const handleProtectedToggle = () => {
    setIsProtected((prevState) => !prevState);
  };

  return (
    <div className={'passphrase-field col-12' + (wrapClassName ? ` ${wrapClassName}` : '')}>
      <div className="name">{label}</div>
      <div className={'pwd-input-wrapper' + (!isProtected ? ' eye-open' : ' eye-close')}>
        <Input {...field} {...props} type={!isProtected ? 'text' : 'password'} className={(className ? ` ${className}` : '') + (meta.error && meta.touched ? ' field--invalid' : '')} />
        <div className="eye-icon" onClick={handleProtectedToggle} />
      </div>
      {onRedirectToForget && (
        <button type="button" className="forget-passphrase-link" onClick={onRedirectToForget}>忘記密碼</button>
      )}
      {!validate && meta.error && meta.touched && (
        <div className="notes warn mt-2">{meta.error}</div>
      )}
      {validate && (
        <>
          <div className={'notes mt-2 grey-notes' + (validGroup[0] ? ' active' : '')}>
            <div className="icon" />
            <span>8-20 個字元</span>
          </div>
          <div className={'notes mt-2 grey-notes' + (validGroup[1] ? ' active' : '')}>
            <div className="icon" />
            <span>需包含大小寫英文及數字</span>
          </div>
          <div className={'notes mt-2 grey-notes' + (validGroup[2] ? ' active' : '')}>
            <div className="icon" />
            <span>不得設定四個以上連續升幂、降幂或相同之英數字（如：ABCD、DCBA、1234、4321、aaaa、1111 等）</span>
          </div>
          <div className={'notes mt-2 grey-notes' + (validGroup[3] ? ' active' : '')}>
            <div className="icon" />
            <span>不得同身分證字號或帳號</span>
          </div>
          <div className={'notes mt-2 grey-notes' + (validGroup[4] ? ' active' : '')}>
            <div className="icon" />
            <span>可設定特殊符號，但不得設定：/、\、$、&、空白或全型英數字</span>
          </div>
        </>
      )}
    </div>
  );
};

InputPasswordField01.defaultProps = {
  validate: false
};

export default InputPasswordField01;
